/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const VolumeLowIcon = /*#__PURE__*/ createSvgIcon(
  'VolumeLowIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8 11.957H5.75a.726.726 0 01-.534-.216.726.726 0 01-.216-.534v-2.5c0-.213.072-.39.216-.535a.726.726 0 01.534-.215H8l2.73-2.73c.235-.235.506-.288.812-.157.305.132.458.366.458.704v8.364c0 .338-.153.572-.458.704-.306.132-.577.08-.813-.156L8 11.956zm7.5-2c0 .514-.125 1.041-.375 1.583s-.604.952-1.063 1.23a.38.38 0 01-.374.01c-.126-.063-.188-.174-.188-.333v-4.98c0-.16.063-.27.188-.333a.38.38 0 01.374.01c.459.264.813.67 1.063 1.219s.375 1.08.375 1.594zm-5-2.375L8.625 9.457H6.5v1h2.125l1.875 1.875v-4.75z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default VolumeLowIcon;
